
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ofArray, tryFind, filter, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap, map as map_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Select } from "../../Components/Select.js";
import { Msg } from "./Types.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { FormContainer } from "../../Components/FormContainer.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { Input } from "../../Components/Input.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initEditLocationView, update as update_1, initNewLocationView } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapLocationId } from "../../Shared/Helper.js";

function BusinessUnitSelect(props) {
    const t = useTranslation()[0];
    const mapBusinessUnit = (businessUnit) => ({
        label: businessUnit.Name,
        value: businessUnit,
    });
    const options = map(mapBusinessUnit, filter((businessUnit_1) => {
        const matchValue = props.Location.BusinessUnitId;
        if (matchValue == null) {
            return true;
        }
        else {
            return businessUnit_1.Id !== matchValue;
        }
    }, props.BusinessUnits));
    let selectedBusinessUnit;
    const matchValue_1 = props.Location.BusinessUnitId;
    if (matchValue_1 == null) {
        selectedBusinessUnit = undefined;
    }
    else {
        const businessUnitId_1 = matchValue_1;
        selectedBusinessUnit = map_1(mapBusinessUnit, tryFind((businessUnit_2) => (businessUnit_2.Id === businessUnitId_1), props.BusinessUnits));
    }
    return createElement(Select, {
        ComponentState: "enabled",
        IsClearable: true,
        Label: t("business_units.business_unit"),
        NoOptionsMessage: "business_units.select.no_options",
        OnChange: (arg) => {
            props.Dispatch(new Msg(2, [arg]));
        },
        Options: options,
        PlaceholderKey: "business_units.select.placeholder",
        TestId: "",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "business_unit")),
        Value: unwrap(selectedBusinessUnit),
    });
}

export function LocationForm(props) {
    const t = useTranslation()[0];
    return createElement(FormContainer, {
        Children: toList(delay(() => {
            let matchValue;
            return append((matchValue = FormState__getValidation(props.FormState, t, "global"), (matchValue == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                Label: matchValue,
            }))), delay(() => append(singleton(createElement(Input, {
                ComponentState: "enabled",
                Label: t("general.name"),
                OnChange: (arg) => {
                    props.Dispatch(new Msg(0, [arg]));
                },
                TestId: "location-form-name",
                ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
                Value: props.Location.Name,
            })), delay(() => append(singleton(createElement(Input, {
                ComponentState: "enabled",
                Label: t("general.description"),
                OnChange: (arg_1) => {
                    props.Dispatch(new Msg(1, [arg_1]));
                },
                TestId: "location-form-description",
                Value: props.Location.Description,
            })), delay(() => (isFeatureEnabled(new Feature(17, [])) ? ((props.AccountSettings.BusinessUnitsEnabled && !props.IsEdit) ? singleton(createElement(BusinessUnitSelect, {
                BusinessUnits: props.BusinessUnits,
                Dispatch: props.Dispatch,
                FormState: props.FormState,
                Location: props.Location,
            })) : empty()) : empty())))))));
        })),
        Header: props.Header,
        OnBack: props.OnBack,
        OnSave: props.OnSave,
    });
}

export function NewLocationView() {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initNewLocationView, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.AccountSettings;
    const matchValue_2 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, location;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            if (matchValue_2.tag === 1) {
                matchResult = 1;
                accountSettings = matchValue_1.fields[0];
                businessUnits = matchValue_2.fields[0];
                location = matchValue.fields[0];
            }
            else {
                matchResult = 0;
            }
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return createElement(Skeleton, {
                Variant: "detail",
            });
        default:
            return createElement(LocationForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("location.create_new_location"),
                IsEdit: false,
                Location: location,
                OnBack: () => {
                    RouterModule_nav(ofArray(["locations"]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(3, []));
                },
            });
    }
}

export function EditLocationView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initEditLocationView, update_1, (_arg, _arg_1) => {
    }), props.LocationId, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Form;
    const matchValue_1 = state_1.AccountSettings;
    const matchValue_2 = state_1.BusinessUnits;
    let matchResult, accountSettings, businessUnits, location;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            if (matchValue_2.tag === 1) {
                matchResult = 1;
                accountSettings = matchValue_1.fields[0];
                businessUnits = matchValue_2.fields[0];
                location = matchValue.fields[0];
            }
            else {
                matchResult = 0;
            }
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return createElement(Skeleton, {
                Variant: "detail",
            });
        default:
            return createElement(LocationForm, {
                AccountSettings: accountSettings,
                BusinessUnits: businessUnits,
                Dispatch: dispatch,
                FormState: state_1.FormState,
                Header: patternInput_1[0]("location.create_new_location"),
                IsEdit: true,
                Location: location,
                OnBack: () => {
                    RouterModule_nav(ofArray(["locations", unwrapLocationId(props.LocationId)]), 1, 1);
                },
                OnSave: () => {
                    dispatch(new Msg(4, []));
                },
            });
    }
}

